export default "__VITE_ASSET__Dhuy9fmy__"